import { render, staticRenderFns } from "./QuestionResults.vue?vue&type=template&id=4c30908f&scoped=true&"
import script from "./QuestionResults.vue?vue&type=script&lang=ts&"
export * from "./QuestionResults.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionResults.vue?vue&type=style&index=0&id=4c30908f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c30908f",
  null
  
)

export default component.exports